// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_btn-info__RSdmY {
  font-size: 1.6rem;
}

.profile_input-info__fAfjH {
  font-size: 1.6rem;
}
.profile_input-info__fAfjH:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.profile_btn-save__vu7lW, .profile_btn-cancer__AMVMY {
  font-size: 1.4rem;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/info/profile.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;AAAI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAER;;AACA;EACI,iBAAA;EACA,gBAAA;AAEJ","sourcesContent":[".btn-info{\n    font-size: 1.6rem;\n}\n.input-info{\n    font-size: 1.6rem;\n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n    }\n}\n.btn-save, .btn-cancer{\n    font-size: 1.4rem;\n    margin-top: 10px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn-info": `profile_btn-info__RSdmY`,
	"input-info": `profile_input-info__fAfjH`,
	"btn-save": `profile_btn-save__vu7lW`,
	"btn-cancer": `profile_btn-cancer__AMVMY`
};
export default ___CSS_LOADER_EXPORT___;
